// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".youtubevideo {\n\tmargin: 40px;\n\twidth: calc(100% - 40px);\n\t/*max-width: 800px;*/\n\tpadding-top: 56%;\n\theight: 0;\n\t/*border:solid;*/\n\tposition: relative;\n}\n\n.youtubevideo-video {\n\tposition: absolute;\n\theight: 100%;\n\twidth: 100%;\n\tleft: 0;\n\ttop: 0;\n}", ""]);
// Exports
module.exports = exports;
